import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import { string } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import {
  params, shape, string as stringType, useDataModel, bool as boolType, arrayOf as arrayType
} from '@thd-nucleus/data-sources';
import styles from './tools-materials.module.scss';

const ToolsMaterials = ({ articleGUID }) => {
  const { data, loading, error } = useDataModel('article', {
    variables: { articleGUID }
  });

  const artType = data?.article?.articleType;
  const prodList = data?.article?.relatedProducts || [];

  const [isHidden, showHide] = useState(!(artType === 'ah'));

  const productCard = (product, index) => {
    return (
      <div
        key={`related-products-${index}`}
        className={`${styles.product_card}${(index > 5)
        && isHidden ? ` ${styles.hidden_card}` : ''}`}
      >
        <a href={product?.url}>
          <div className={styles.product_thumb}>
            <Image
              src={product.imageURL}
              alt={product.title}
              title=""
              height={85}
              width={85}
              className=""
            />
          </div>
        </a>
        <a href={product?.url}>
          <div className={styles.product_title}>{product?.title}</div>
        </a>
      </div>
    );
  };

  if (!(prodList.length > 0)) {
    return null;
  }

  if (artType === 'ah') {
    const tools = [];
    const materials = [];
    prodList.forEach((product, i) => {
      if (product?.isMaterial === 'true') {
        materials.push(product);
      } else {
        tools.push(product);
      }
    });

    return (
      <div className={styles.tools_materials}>
        {tools.length > 0 && <h4 className={styles.project_guide_header}>Tools</h4>}
        {tools.map((product, i) => productCard(product, i))}
        <hr className={styles.mobile_only} />
        {materials.length > 0 && <h4 className={styles.project_guide_header}>Materials</h4>}
        {materials.map((product, i) => productCard(product, i))}
      </div>
    );
  }

  return (
    <div className={styles.tools_materials}>
      <h4>{artType === 'ap' ? 'Shop this Project' : 'Related Products'}</h4>
      {prodList.map((product, i) => productCard(product, i))}
      {(prodList.length > 6)
        && (
          <div className={styles.button_container}>
            <button
              type="button"
              className={styles.see_more}
              onClick={() => showHide(!isHidden)}
            >See {isHidden ? 'More' : 'Less'}
            </button>
          </div>
        )}
    </div>
  );
};

ToolsMaterials.propTypes = {
  articleGUID: string.isRequired
};

ToolsMaterials.displayName = 'ToolsMaterials';

ToolsMaterials.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    articleType: stringType(),
    relatedProducts: arrayType(shape({
      imageURL: stringType(),
      isMaterial: boolType(),
      title: stringType(),
      url: stringType(),
    }))
  }),
};
export { ToolsMaterials };
